"use client"

import { useEffect } from "react"
import {
  pdpVariantCookieName,
  type PdpVariantPersistenceAction,
} from "../../lib/pdp-presentation-variant"

type Props = {
  productId: string
  action: PdpVariantPersistenceAction
  secure: boolean
}

const MAX_AGE_SECONDS = 180 * 24 * 60 * 60

const PdpVariantCookieSync = ({ productId, action, secure }: Props) => {
  useEffect(() => {
    if (action.type === "none") return

    const cookieName = pdpVariantCookieName(productId)
    const secureAttribute = secure ? "; Secure" : ""

    if (action.type === "clear") {
      document.cookie = `${cookieName}=; Path=/; Max-Age=0; SameSite=Lax${secureAttribute}`
      return
    }

    document.cookie = `${cookieName}=${encodeURIComponent(action.key)}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${secureAttribute}`
  }, [action, productId, secure])

  return null
}

export default PdpVariantCookieSync
